import { useState, type Dispatch, type SetStateAction } from "react";

/**
 * `useState` that resets to `initial` whenever `key` changes, in the same
 * render (so the stale value never paints).
 */
export function useKeyedState<K, S>(
  key: K,
  initial: S | (() => S),
): [S, Dispatch<SetStateAction<S>>] {
  const [state, setState] = useState(initial);
  const [prevKey, setPrevKey] = useState(key);
  if (!Object.is(prevKey, key)) {
    setPrevKey(key);
    setState(initial);
  }
  return [state, setState];
}
